import { render, staticRenderFns } from "./McnTaskFansRecord.vue?vue&type=template&id=ed1b5550&scoped=true"
import script from "./McnTaskFansRecord.vue?vue&type=script&lang=js"
export * from "./McnTaskFansRecord.vue?vue&type=script&lang=js"
import style0 from "./McnTaskFansRecord.vue?vue&type=style&index=0&id=ed1b5550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1b5550",
  null
  
)

export default component.exports